// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import App from './App';
import router from './router';
import Navigation from './components/navigation/navigation';
import Thumbnail from './components/thumbnail/thumbnail';

Vue.component('navigation', Navigation);
Vue.component('thumbnail', Thumbnail);

Vue.config.productionTip = false;

/* eslint-disable no-new */
new Vue({
    el: '#app',
    router,
    template: '<App/>',
    components: {
        App,
        Navigation,
        Thumbnail
    }
});



// WEBPACK FOOTER //
// ./src/main.js